<div class="content">
	<p>{{ 'install-prompt.ios' | translate }}</p>
	<div class="full-width"><mat-icon>arrow_downward</mat-icon></div>
</div>
<button class="btn-close" mat-icon-button (click)="close()" aria-label="Close">
	<mat-icon>close</mat-icon>
</button>
